(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddAssignment", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddAssignmentView.html",
            controller: ["messageService", "FILE_FORMATS", "$translate", "Upload", "$timeout", LearningItemAddAssignmentCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddAssignmentCtrl(messageService, FILE_FORMATS, $translate, Upload, $timeout) {
            var vm = this;
            vm.maxFilesAllowed = 1;
            vm.acceptedFiles = FILE_FORMATS.assignment;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 300,
                plugins: "autoresize code wordcount",
                language: lang
            };
            vm.upload = function (file) {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningitems/temp/files",
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            if (response.data.length > 0) {
                                vm.wizard.formData.specificInfo.template = response.data[0];
                                messageService.success("common.dropzone.uploadedFileMessage");
                                vm.progress = 0;
                            }
                        });
                    }, function (response) {
                        messageService.error(response);
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.removeFile = function () {
                vm.wizard.formData.specificInfo.template = null;
            };
            vm.validateFile = function () {
                if (vm.wizard.formData.specificInfo.template)
                    return "maxFiles";
                return true;
            };
        }
    });
}());
